export const CentMultiplier = 100

export enum BidMultiplier {
    Original = 1,
    Ten = 10,
    Hundred = 100
}